/**
 * Kľúče cache obchodov — samostatne, aby ich `contacts.ts` (invalidácia detailu obchodu) importoval bez
 * cyklu s `deals.ts`, ktorý importuje `contacts.ts`. Tvar sedí s priamymi `invalidateQueries` na stránkach
 * obchodov: zoznamy ['my-deals', …], pipeline ['pipeline'], detail ['deal', id].
 */

/** Fully-resolved list filters — the page does the RBAC resolution, the hook
 * just serialises. `view` maps to the active/archive tab. */
export interface DealListFilters {
  view: 'active' | 'archive'
  page: number
  stageId?: string
  /** Resolved agent scope (page applies onlyMine / role rules before passing). */
  agentId?: string
  /** Resolved branch scope. */
  branchId?: string
  /** Cache-only discriminator (not sent to the API), e.g. SUPER_ADMIN tenant. */
  tenantId?: string
  dateFrom?: string
  dateTo?: string
  valueMin?: string
  valueMax?: string
  search?: string
  sortBy: string
  sortOrder: 'asc' | 'desc'
}

export const dealKeys = {
  /** Prefix matching every paginated deal list — use for broad invalidation. */
  lists: ['my-deals'] as const,
  list: (filters: DealListFilters) => ['my-deals', filters] as const,
  tiperList: ['my-deals-tiper'] as const,
  pipeline: ['pipeline'] as const,
  /** Prefix matching every deal detail — úlohy, udalosti a strany sa zobrazujú aj v detaile obchodu. */
  details: ['deal'] as const,
  detail: (id: string) => ['deal', id] as const,
}
